var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseFilterRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.597656,
    y: 0.211914,
    width: 28.3333,
    height: 28.3333,
    rx: 14.1667,
    fill: "#EEEEEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.788 14.3776L18.9119 11.2609C19.0487 11.1241 19.1256 10.9386 19.1256 10.7451C19.1256 10.5516 19.0487 10.3661 18.9119 10.2293C18.7751 10.0925 18.5896 10.0156 18.3961 10.0156C18.2027 10.0156 18.0171 10.0925 17.8803 10.2293L14.7636 13.3532L11.6469 10.2293C11.5101 10.0925 11.3246 10.0156 11.1311 10.0156C10.9376 10.0156 10.7521 10.0925 10.6153 10.2293C10.4785 10.3661 10.4016 10.5516 10.4016 10.7451C10.4016 10.9386 10.4785 11.1241 10.6153 11.2609L13.7392 14.3776L10.6153 17.4943C10.5472 17.5618 10.4931 17.6422 10.4563 17.7307C10.4194 17.8193 10.4004 17.9142 10.4004 18.0101C10.4004 18.106 10.4194 18.201 10.4563 18.2895C10.4931 18.378 10.5472 18.4584 10.6153 18.5259C10.6828 18.594 10.7632 18.6481 10.8517 18.685C10.9402 18.7218 11.0352 18.7408 11.1311 18.7408C11.227 18.7408 11.322 18.7218 11.4105 18.685C11.499 18.6481 11.5794 18.594 11.6469 18.5259L14.7636 15.402L17.8803 18.5259C17.9478 18.594 18.0282 18.6481 18.1167 18.685C18.2053 18.7218 18.3002 18.7408 18.3961 18.7408C18.492 18.7408 18.587 18.7218 18.6755 18.685C18.764 18.6481 18.8444 18.594 18.9119 18.5259C18.98 18.4584 19.0341 18.378 19.071 18.2895C19.1078 18.201 19.1268 18.106 19.1268 18.0101C19.1268 17.9142 19.1078 17.8193 19.071 17.7307C19.0341 17.6422 18.98 17.5618 18.9119 17.4943L15.788 14.3776Z",
    fill: "#F34B4B",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseFilterRed);
export default __webpack_public_path__ + "static/media/CloseFilterRed.69f044d5946002c77f7f357fd527287d.svg";
export { ForwardRef as ReactComponent };